<template>
  <div class="case">
    <banner img="../assets/img/banner.png"
            title="解决方案" />
    <div class="case-wrap">
      <el-row :gutter="20">
        <el-col :span="50"
                v-for="(item,index) in list"
                :key="index">
          <div class="case-item">
            <img class="case-img"
                  :src="imgFn(item.imgSrcName)"
                 alt="">
            <div class="case-list-bottom">
              <h3 class="case-name">{{item.name}} </h3>
              <p class="case-des">{{item.des}}</p>
              <el-button type="text"
                         @click="detailHandle(item.id)" v-if="item.des">
                想看详情
                <i class="el-icon-right el-icon--right" />
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Banner from '../components/Banner';
export default {
  components: {
    Banner,
  },
  data() {
    return {
      indexId: this.$route.query.id - 1,
      loading: false,
      caseList: [
        {
          list: [
            { id: 1, name: '上海电信', des: '上海电信云协作项目', imgSrcName:'shdx' },
            { id: 2, name: '云南电信', des: '', imgSrcName:'yndx' },
            { id: 3, name: '中电数智', des: '', imgSrcName:'zdsz' },
            { id: 4, name: '中电万维', des: '', imgSrcName:'zdww' },
          ],
        },
        {
          list: [
            { id: 2, name: '上海消防', des: '上海消防语音项目', imgSrcName:'shxf' },
          ],
        },
        {
          list: [
            { id: 3, name: '星星冷链', des: '浙江星星冷链IOT监控平台项目', imgSrcName:'xxls' },
            { id: 4, name: '羊庄管理系统', des: '香道泉羊”羊庄门店管理系统项目', imgSrcName:'xdqy' },
          ],
        },
        {
          list: [
            { id: 5, name: '西湖区卫健局', des: '杭州西湖区卫健局影像AI项目', imgSrcName:'hzxhwjw' },
            { id: 6, name: '上海市卫健委', des: '上海市卫健委推广项目-AI助力分级诊疗项目', imgSrcName:'shwjw' },
          ],
        },
      ],
      list: [],
    };
  },
  watch: {
    '$route.query.id'() {
      this.indexId = this.$route.query.id - 1;
      this.list = this.caseList[this.indexId].list;
    },
  },
  methods: {
    detailHandle(id) {
      this.$router.push(`/casedetails/${id}`);
    },
    imgFn(name) {
      return require(`../assets/kz/${name}.png`);
    }
  },
  mounted() {
    this.list = this.caseList[this.indexId].list;
  },
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  &-wrap {
    display: flex;
    justify-content: center;
    margin: 40px 0;

  }
  &-item {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    width: 299px;
    height: 400px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: all 0.5s;
  }
  &-list-bottom {
    background-color: #fff;
    padding: 40px;
    flex: 1;
    position: relative;
  }
  &-name {
    font-size: 32px;
    margin-bottom: 10px;
  }
  &-des {
    height: 80px;
  }
  &-img {
    width: 100%;
    max-width: 400px;
  }
}
.price {
  margin-top: 10px;
}
</style>